import React from 'react';
import './headerEvaluation.css'

import { Layout} from 'antd';
const { Header } = Layout;

const HeaderEvaluation = ({ orgLogo }) => {
    return <Header className='headerEvaluation'>
        <div className="logo">
            <img src='/talentha-color.png' alt='Logo Talentha' />
        </div>
        <div className="logo">
            {orgLogo && <img src={orgLogo} alt='Logo Empresa' />}
        </div>
    </Header>
}

export default HeaderEvaluation;